export default __webpack_public_path__ + "static/media/PersonalWebsiteBanner.369d7dc3.png";